import React from 'react';
import { GoogleLogin, CredentialResponse } from '@react-oauth/google';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

interface Props {
  onLoginStart?: () => void;
  onLoginError?: () => void;
}

const GoogleLoginButton: React.FC<Props> = ({ onLoginStart, onLoginError }) => {
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSuccess = async (credentialResponse: CredentialResponse) => {
    if (credentialResponse.credential) {
      onLoginStart?.();
      try {
        const needsCompany = await login(credentialResponse.credential);
        navigate(needsCompany ? '/setup-company' : '/dashboard');
      } catch (error) {
        console.error('Login error:', error);
        onLoginError?.();
      }
    }
  };

  const handleError = () => {
    console.error('Login Failed');
    onLoginError?.();
  };

  return (
    <GoogleLogin
      onSuccess={handleSuccess}
      onError={handleError}
      useOneTap
    />
  );
};

export default GoogleLoginButton;
